const hotel = {
  availableMealPlans: "خطط الوجبات المتاحة", // translated 
  availableRoomsTypes: "أنواع الغرف المتاحة", // translated 
  cancellationPolicy: "سياسة الإلغاء", // translated 
  cancellationRules: "قواعد الإلغاء", // translated 
  freeCancellationAvailable: "الإلغاء المجاني متاح", // translated 
  nonRefundable: "غير قابل للاسترجاع", // translated 
  priceFor: "السعر لاجل", // translated 
  nights: "ليالي", // translated 
  totalPrice: "السعر الكلي", // translated 
  seeAvailability: "انظر التوفر", // translated 
  myProfile: "ملفي", // translated 
  travelTrust: "ثقة السفر", // translated 
  signIn: "تسجيل الدخول", // translated 
  searchNow: "ابحث الآن", // translated 
  policy: "سياسة", // translated 
  cxlRules: "قواعد CXL", // translated 
  room: "غرفة", // translated 
  cxlPolicy: "سياسة CXL", // translated 
  beddingType: "نوع الفراش", // translated 
  hotelName: "اسم فندق", // translated 
  reservationDate: "تاريخ الحجز", // translated 
  maxPax: "ماكس باكس", // translated 
};




export default hotel;
